import * as React from 'react';
import { ChildMutateProps, graphql } from 'react-apollo';

import { FormsLocale } from '../../../components/ContactPage/Forms/forms.locale';
import SalesFormComponent, { FormData } from '../../../components/ContactPage/Forms/SalesForm';
import { ContactSalesMutationArgs, Mutation, SalesContactInput } from '../../../GraphQL';
import contactSalesMutation from './contactSalesMutation.gql';
import { formErrorHandler } from '../../Validator/formErrorHandler';

interface OwnProps {
  locale: FormsLocale;
}

interface ContactSalesVariables {
  contact: SalesContactInput;
  message: string;
}

export interface SalesFormProps
  extends ChildMutateProps<OwnProps, Mutation, ContactSalesMutationArgs> {}

const SalesForm: React.SFC<SalesFormProps> = ({ locale, mutate }) => {
  const handleFormSubmit = (values: FormData) => {
    const filteredValues = {
      ...values,
      contact: {
        ...values.contact,
        asNumber: values.contact.noAs ? null : values.contact.asNumber,
        noAs: undefined,
      },
    };

    return mutate({
      variables: filteredValues,
    })
      .then(
        ({ data }) =>
          data.contactSales.successful
            ? Promise.resolve()
            : Promise.reject(data.contactSales.validationErrors),
      )
      .catch(error => formErrorHandler(error));
  };

  return <SalesFormComponent locale={locale} onSubmit={handleFormSubmit} />;
};

export default graphql<OwnProps, Mutation, ContactSalesVariables, SalesFormProps>(
  contactSalesMutation,
)(SalesForm);



// WEBPACK FOOTER //
// /www/client/src/containers/ContactPage/SalesForm/SalesForm.tsx